import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// en
import enAgents from "./en/agents.json";
import enAuditLog from "./en/auditLog.json";
import enAuth from "./en/auth.json";
import enCommon from "./en/common.json";
import enCompanyContext from "./en/companyContext.json";
import enHelp from "./en/help.json";
import enHitl from "./en/hitl.json";
import enHome from "./en/home.json";
import enKnowledgeBases from "./en/knowledgeBases.json";
import enMarketplace from "./en/marketplace.json";
import enMcps from "./en/mcps.json";
import enObservability from "./en/observability.json";
import enObservabilityAgent from "./en/observabilityAgent.json";
import enPii from "./en/pii.json";
import enPromptTones from "./en/promptTones.json";
import enScheduler from "./en/scheduler.json";
import enServiceUsers from "./en/serviceUsers.json";
import enSkills from "./en/skills.json";
import enTasks from "./en/tasks.json";
import enTeams from "./en/teams.json";
import enTeamSessions from "./en/teamSessions.json";
import enThreads from "./en/threads.json";
import enUsers from "./en/users.json";
import enDirectChat from "./en/directChat.json";

// es
import esAgents from "./es/agents.json";
import esAuditLog from "./es/auditLog.json";
import esAuth from "./es/auth.json";
import esCommon from "./es/common.json";
import esCompanyContext from "./es/companyContext.json";
import esHelp from "./es/help.json";
import esHitl from "./es/hitl.json";
import esHome from "./es/home.json";
import esKnowledgeBases from "./es/knowledgeBases.json";
import esMarketplace from "./es/marketplace.json";
import esMcps from "./es/mcps.json";
import esObservability from "./es/observability.json";
import esObservabilityAgent from "./es/observabilityAgent.json";
import esPii from "./es/pii.json";
import esPromptTones from "./es/promptTones.json";
import esScheduler from "./es/scheduler.json";
import esServiceUsers from "./es/serviceUsers.json";
import esSkills from "./es/skills.json";
import esTasks from "./es/tasks.json";
import esTeams from "./es/teams.json";
import esTeamSessions from "./es/teamSessions.json";
import esThreads from "./es/threads.json";
import esUsers from "./es/users.json";
import esDirectChat from "./es/directChat.json";
import ptAgents from "./pt-BR/agents.json";
import ptAuditLog from "./pt-BR/auditLog.json";
import ptAuth from "./pt-BR/auth.json";
import ptCommon from "./pt-BR/common.json";
import ptCompanyContext from "./pt-BR/companyContext.json";
import ptHelp from "./pt-BR/help.json";
import ptHitl from "./pt-BR/hitl.json";
import ptHome from "./pt-BR/home.json";
import ptKnowledgeBases from "./pt-BR/knowledgeBases.json";
import ptMarketplace from "./pt-BR/marketplace.json";
import ptMcps from "./pt-BR/mcps.json";
import ptObservability from "./pt-BR/observability.json";
import ptObservabilityAgent from "./pt-BR/observabilityAgent.json";
import ptPii from "./pt-BR/pii.json";
import ptPromptTones from "./pt-BR/promptTones.json";
import ptScheduler from "./pt-BR/scheduler.json";
import ptServiceUsers from "./pt-BR/serviceUsers.json";
import ptSkills from "./pt-BR/skills.json";
import ptTasks from "./pt-BR/tasks.json";
import ptTeams from "./pt-BR/teams.json";
import ptTeamSessions from "./pt-BR/teamSessions.json";
import ptThreads from "./pt-BR/threads.json";
import ptUsers from "./pt-BR/users.json";
// M8: chat direto.
import ptDirectChat from "./pt-BR/directChat.json";

import { useUiStore } from "@/stores/uiStore";

const initialLanguage = useUiStore.getState().language;

void i18n.use(initReactI18next).init({
  lng: initialLanguage,
  fallbackLng: "pt-BR",
  defaultNS: "common",
  interpolation: { escapeValue: false },
  resources: {
    "pt-BR": {
      common: ptCommon,
      auth: ptAuth,
      teams: ptTeams,
      users: ptUsers,
      serviceUsers: ptServiceUsers,
      companyContext: ptCompanyContext,
      home: ptHome,
      agents: ptAgents,
      promptTones: ptPromptTones,
      threads: ptThreads,
      directChat: ptDirectChat,
      help: ptHelp,
      hitl: ptHitl,
      marketplace: ptMarketplace,
      teamSessions: ptTeamSessions,
      auditLog: ptAuditLog,
      pii: ptPii,
      observability: ptObservability,
      observabilityAgent: ptObservabilityAgent,
      knowledgeBases: ptKnowledgeBases,
      mcps: ptMcps,
      skills: ptSkills,
      tasks: ptTasks,
      scheduler: ptScheduler,
    },
    en: {
      common: enCommon,
      auth: enAuth,
      teams: enTeams,
      users: enUsers,
      serviceUsers: enServiceUsers,
      companyContext: enCompanyContext,
      home: enHome,
      agents: enAgents,
      promptTones: enPromptTones,
      threads: enThreads,
      directChat: enDirectChat,
      help: enHelp,
      hitl: enHitl,
      marketplace: enMarketplace,
      teamSessions: enTeamSessions,
      auditLog: enAuditLog,
      pii: enPii,
      observability: enObservability,
      observabilityAgent: enObservabilityAgent,
      knowledgeBases: enKnowledgeBases,
      mcps: enMcps,
      skills: enSkills,
      tasks: enTasks,
      scheduler: enScheduler,
    },
    es: {
      common: esCommon,
      auth: esAuth,
      teams: esTeams,
      users: esUsers,
      serviceUsers: esServiceUsers,
      companyContext: esCompanyContext,
      home: esHome,
      agents: esAgents,
      promptTones: esPromptTones,
      threads: esThreads,
      directChat: esDirectChat,
      help: esHelp,
      hitl: esHitl,
      marketplace: esMarketplace,
      teamSessions: esTeamSessions,
      auditLog: esAuditLog,
      pii: esPii,
      observability: esObservability,
      observabilityAgent: esObservabilityAgent,
      knowledgeBases: esKnowledgeBases,
      mcps: esMcps,
      skills: esSkills,
      tasks: esTasks,
      scheduler: esScheduler,
    },
  },
});

// Subscribe ao Zustand store para refletir trocas de idioma feitas pelo
// LanguageToggle em tempo real (sem reload de pagina).
useUiStore.subscribe((state, prev) => {
  if (state.language !== prev.language) {
    void i18n.changeLanguage(state.language);
  }
});

export default i18n;
